import React from 'react';

import {WindowFrame} from 'shared/pages/LandingPage/ScrollShowcase/WindowFrame';

import './styles.scss';

export interface ISlide {
    heading: string;
    image: string;

}

interface IScrollShowcaseProps {
    slides: ISlide[];
}

export const ScrollShowcase = ({slides}: IScrollShowcaseProps) => {
    const containerRef = React.useRef<HTMLDivElement>(null);
    const [activeIndex, setActiveIndex] = React.useState(0);

    React.useEffect(() => {
        const onScroll = () => {
            if (!containerRef.current) return;
            const {top} = containerRef.current.getBoundingClientRect();
            const index = Math.floor((-top / window.innerHeight) + 0.4);
            setActiveIndex(Math.max(0, Math.min(index, slides.length - 1)));
        };
        window.addEventListener('scroll', onScroll, {passive: true});
        return () => window.removeEventListener('scroll', onScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div ref={containerRef} className='scroll-showcase'>
            <div className='scroll-showcase__sticky'>
                <h2 className="scroll-showcase__heading">
                    {slides[activeIndex].heading}
                </h2>
                <WindowFrame>
                    <img
                        src={slides[activeIndex].image}
                        alt={slides[activeIndex].heading}
                        style={{
                            width: '100%',
                            height: 'calc(100% - 32px)',
                            objectFit: 'cover',
                            display: 'block',
                        }}
                    />
                </WindowFrame>
            </div>
            {slides.map((slide, index) => (
                <div key={index} className="scroll-showcase__spacer" />
            ))}
        </div>
    );
};